import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import ArticleList from '../subcomponents/ArticleList';
import ContentLoader from '../subcomponents/ContentLoader';
import PageLayout from '../subcomponents/PageLayout';
import { fetchInformation } from './informationSlice';

export default function InformationPage() {
    const dispatch = useDispatch();
    const { information } = useSelector((state) => state.information);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    useEffect(() => {
        dispatch(fetchInformation());
    }, [dispatch]);

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.INFORMATION}
            content={
                <ContentLoader
                    successCondition={information.status === "success"}
                    errorCondition={information.status === "failed"}
                    content={
                        <ArticleList articles={information.data} status={information.status} pagination rowHeight={60} />
                    }
                />
            }
            bottomBar
            disableHeaderBackground
            disableContentBackground
        />
    );
}
